import * as types from './layout.actionType';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  showTooltip: true
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_SHOWTOOLTIP:
      return state.merge({ ...state, showTooltip: action.payload });
    default:
      return state;
  }
}
